import React from "react";
import * as agent from "../agent";
import InnerLink from './InnerLink';
import { MaterialTextField } from "./MaterialInput";
import renderHTML from 'react-render-html';
import { connect } from "react-redux";
import { reduxForm, Field, reset } from "redux-form";
import { CONTRACT_UPDATED } from "../constants/actionTypes";
import { FormattedDate, FormattedTime } from "react-intl";
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import SubmitButton from './SubmitButton';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

const addCheckForm = ({contractId, onAddTerrorCheck, handleSubmit}) => (
    <form className="common-form"
          onSubmit={handleSubmit(data => onAddTerrorCheck(contractId, data))} >
        <Field component={MaterialTextField}
               name="note"
               placeholder="Чисто"
               label="Комментарий" />
        <SubmitButton label="Добавить" />
    </form>
);

const AddCheckForm = reduxForm({ form: "security-terror" })(addCheckForm);

class securityChecks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
            checkResult: "",
            error: false,
            errorMessage: ""
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        const { clientLastname, clientFirstname } = this.props;
        agent.Clients.checkTerrorist(`${clientLastname.trim()} ${clientFirstname.trim()}`)
            .then(res => this.setState({checked: true, checkResult: res}))
            .catch(e => this.setState({error: true, errorMessage: e.message }));

    }

    render() {

        const { clientLastname, clientFirstname, terror = [], contractId, onAddTerrorCheck, onResolveProblem } = this.props;
        const { checked, checkResult: {Html}, error, errorMessage } = this.state;
        return (
            <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
                <Grid container justify="center" spacing={16}>
                    <Grid item className="ultrawide-column">
                    { terror.length ?
                        <Table padding="checkbox">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Дата</TableCell>
                                    <TableCell>Автор</TableCell>
                                    <TableCell>Комментарий</TableCell>
                                    <TableCell>&nbsp;</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            { terror.map(({ date, author: {id, fullname = ""} = {}, status, note, _id}, i) =>
                                <TableRow key={i}>
                                    <TableCell>
                                        <FormattedDate value={date}
                                                       day="numeric"
                                                       month="numeric"
                                                       year="numeric" />
                                        <br />
                                        <FormattedTime value={date}
                                                       hour="numeric"
                                                       minute="numeric"
                                                       second="numeric" />
                                    </TableCell>
                                    <TableCell>
                                        { id ? <InnerLink href={`/user/${id}`} label={fullname.split(" ")[0]} /> : ""}
                                    </TableCell>
                                    <TableCell>
                                        {status && !note ? "Чисто" : note}
                                    </TableCell>
                                    <TableCell>
                                        <IconButton disabled={status} onClick={() => onResolveProblem("terror", _id)} >
                                            { status ? <CheckCircleOutlineIcon /> : <HighlightOffIcon /> }
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                        </Table> : <Typography paragraph>Проверок еще не было</Typography>
                    }
                    <AddCheckForm contractId={contractId} onAddTerrorCheck={onAddTerrorCheck} />
                    </Grid>
                    <Grid item className="ultrawide-column">
                        <Typography paragraph>Поиск в базе Росфинмониторинга по запросу '{clientLastname} {clientFirstname}'</Typography>
                        { error ?
                            <Typography paragraph>{errorMessage}</Typography> :
                            (checked ? renderHTML(Html) :
                            <React.Fragment>
                                <Typography paragraph>Ожидайте...</Typography>
                                <CircularProgress />
                            </React.Fragment>)
                        }
                    </Grid>
                </Grid>
            </Paper>
        )
    }
}


const SecurityChecks = connect(
    null,
    dispatch => ({
        onAddTerrorCheck: (contractId, check) =>
            agent.Contract.addTerrorCheck(contractId, check)
            .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
            .then(dispatch(reset('security-terror'))),
        onResolveProblem: (table, checkId) =>
            agent.Contract.resolveProblem(table, checkId)
            .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
    })
)(reduxForm({form: "security-terror"})(securityChecks));

export default SecurityChecks;



// WEBPACK FOOTER //
// ./src/components/SecurityChecks.js